var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'card-picker-card',
    'smooth-shadow',
    { 'width-large': _vm.large },
    { 'width-medium': _vm.medium } ]},[_c('div',{staticClass:"contents"},[_vm._t("default")],2),_c('div',{staticClass:"footer"},[_c('Button',{attrs:{"type":'secondary',"icon":"clear","text":"Cancel"},on:{"click":function($event){return _vm.$emit('onClickCancel')}}}),_c('Button',{attrs:{"type":'primary',"text":"Apply","icon":"check"},on:{"click":function($event){return _vm.$emit('onClickApply')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }